import React from 'react'
import { observer } from 'mobx-react-lite'
import { Badge, Button, Modal, ModalBody, ModalHeader } from '@evertel/web/ui'
import { APIDataAgreementDocument } from '@evertel/types'
import { AgreementTextEditor } from '../elements/AgreementTextEditor'

interface AgreementPreviewModalProps {
    visible: boolean
    document: APIDataAgreementDocument | null
    onClose: () => void
}

const AgreementPreviewModal: React.FC<AgreementPreviewModalProps> = observer(({
    visible,
    document,
    onClose
}) => {

    return (
        <Modal
            visible={visible}
            onClose={onClose}
            size="lg"
        >
            <ModalHeader
                title={
                    <>
                        {document?.name ?? ''}
                        {document?.version && (
                            <Badge
                                color="primary"
                                variant="soft"
                                className="ms-2"
                                style={{ fontSize: '0.7rem', verticalAlign: 'middle' }}
                            >
                                v{document.version}
                            </Badge>
                        )}
                    </>
                }
            />
            <ModalBody>
                <AgreementTextEditor
                    value={document?.content ?? ''}
                    editable={false}
                    maxHeight={500}
                    minHeight={100}
                />
                <div className="d-flex justify-content-end mt-3">
                    <Button
                        color="primary"
                        onClick={onClose}
                    >
                        Close
                    </Button>
                </div>
            </ModalBody>
        </Modal>
    )

})

AgreementPreviewModal.displayName = 'AgreementPreviewModal'
export { AgreementPreviewModal }
